import * as React from "react";
import "./App.css";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Fragment, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login/login";
import secureLocalStorage from "react-secure-storage";
import ResetPassword from "./pages/Login/ResetPassword";
import NotFound from "./pages/Not Found/NotFound";
import ResetMyPassword from "./user page/ResetPassword";
import { getClaim } from "./actions/claim";
import { getCategory } from "./actions/category";
import { getDepartment } from "./actions/department";
import { pendingClaims } from "./actions/pendingClaims";
import { getLocations } from "./actions/locations";
import InternetConnectionMonitor from "./pages/Internet Connection/InternetConnection";
import { getApprovedClaims } from "./actions/Approved";
import { getAllUsers, updateUser } from "./actions/user";
import Department from "./pages/Department/Department";
import Category from "./pages/Category/Category";
import Approval from "./pages/Approvals/Approval";
import ClaimVerification from "./pages/Claim verification/ClaimVerification";
import UserAccountPage from "./user page/UserAccountPage";
import Report from "./pages/Claim Report/Report";
import Restrict from "./pages/Restrict/Restrict";
import ClaimDetail from "./pages/Claim verification copy/ClaimVerification";
import { Toaster } from "react-hot-toast";
import AppLayout from "./ui/AppLayout";
import { getAdminStats } from "./actions/adminStats";
import { getBranchStats } from "./actions/branchStats";
import ProtectedRoute from "./ui/ProtectedRoute";
import ImprestExpenditure from "./pages/imprest/imprest expense";
import { Helmet, HelmetProvider } from "react-helmet-async";
import io from "socket.io-client";
import EntryCondition from "./pages/EntryCondition/EntryCondition";
const socket = io();
const App = () => {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const dispatch = useDispatch();
  useEffect(() => {
    if (user) {
      dispatch(getClaim());
      dispatch(getCategory());
      dispatch(getDepartment());
      dispatch(pendingClaims());
      dispatch(getLocations());
      dispatch(getApprovedClaims());
      dispatch(getAllUsers());
      dispatch(getAdminStats());
      dispatch(getBranchStats());
    }
  }, [dispatch, user]);
  useEffect(() => {
    socket.on("newClaim", () => {
      dispatch(getClaim());
      dispatch(pendingClaims());
      dispatch(getApprovedClaims());
      dispatch(getAdminStats());
      dispatch(getBranchStats());
    });

    // Clean up
    return () => {
      socket.off("submitClaim");
      socket.off("connect");
      socket.off("connect_error");
      socket.off("disconnect");
    };
  }, [dispatch]);
  let allowApproval = false;
  if (
    user?.results?.e_claim === "Administrator" ||
    user?.results?.e_claim === "Approver"
  ) {
    allowApproval = true;
  } else {
    allowApproval = false;
  }
  React.useEffect(() => {
    if (user) {
      dispatch(
        updateUser(user?.results?._id, {
          login: "yes",
          system: "claim",
        })
      );
    }
  }, [dispatch, user]);

  return (
    <HelmetProvider>
      <Helmet defaultTitle='eClaim' />
      {user?.results?.e_claim === "Restricted" ? (
        <Restrict />
      ) : (
        <div>
          <Fragment>
            <InternetConnectionMonitor />

            <Routes>
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }>
                <Route index element={<Navigate replace to={"/claim/"} />} />

                <Route path='/claim/' element={<EntryCondition />} />
                {allowApproval && (
                  <Route path='/claim/report' element={<Report />} />
                )}
                <Route path='/claim/category' element={<Category />} />
                {allowApproval && (
                  <Route path='/claim/approval' element={<Approval />} />
                )}
                <Route path='/claim/user-page' element={<UserAccountPage />} />
                <Route
                  path='/claim/claim-verification'
                  element={<ClaimVerification />}
                />
                <Route path='/claim/imprest' element={<ImprestExpenditure />} />
                <Route path='/claim/claim-details' element={<ClaimDetail />} />
                <Route path='/claim/department' element={<Department />} />
              </Route>
              <Route path='/claim/login' element={<Login />} />
              <Route path='/claim/resetPassword' element={<ResetPassword />} />
              <Route
                path='/claim/resetMyPassword/:token'
                element={<ResetMyPassword />}
              />
              <Route path='*' element={<NotFound />} />
            </Routes>

            <Toaster
              position='top-center'
              gutter={12}
              containerStyle={{ margin: "8px" }}
              toastOptions={{
                success: {
                  duration: 3000,
                },
                error: {
                  duration: 6000,
                },
                style: {
                  fontSize: "12px",
                  maxWidth: "500px",
                  padding: "12px 18px",
                  backgroundColor: "#ffffff",
                  color: "#6b7280",
                },
              }}
            />
          </Fragment>
        </div>
      )}
    </HelmetProvider>
  );
};

export default App;
